import { Component } from '@angular/core';

@Component({
  selector: 'app-meta-novos-processos',
  templateUrl: 'meta-novos-processos.component.html',
  styleUrls: ['meta-novos-processos.component.scss']
})
export class MetaNovosProcessosComponent {
  constructor() { }
}
